import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// 1:1 с mcms-front. Хранит состояние mobile-сайдбара (открыт/закрыт).
// На lg+ Sidebar всегда видимый, slice игнорируется.

interface SidebarState {
  isMobileSidebarOpen: boolean;
  // Collapse desktop-сайдбара (Chevron-кнопка в Header). У фронтендера в
  // оригинальном sidebarSlice этого нет — это наша добавка (была фича в
  // legacy кабинете, согласовано с пользователем).
  isSidebarCollapsed: boolean;
}

const initialState: SidebarState = {
  isMobileSidebarOpen: false,
  isSidebarCollapsed: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleMobileSidebar(state) {
      state.isMobileSidebarOpen = !state.isMobileSidebarOpen;
    },
    setMobileSidebar(state, action: PayloadAction<boolean>) {
      state.isMobileSidebarOpen = action.payload;
    },
    toggleSidebarCollapsed(state) {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.isSidebarCollapsed = action.payload;
    },
  },
});

export const {
  toggleMobileSidebar,
  setMobileSidebar,
  toggleSidebarCollapsed,
  setSidebarCollapsed,
} = sidebarSlice.actions;

export const selectIsSidebarCollapsed = (state: { sidebar: SidebarState }) =>
  state.sidebar.isSidebarCollapsed;

export default sidebarSlice.reducer;
